// extracted by mini-css-extract-plugin
export default {"productImage":"AddProduct_productImage__lvN0R","container":"AddProduct_container__SKy3c"};